import { observable, action } from 'mobx';

class DriverStore {
    constructor(api) {
        this.api = api;
    }

    @observable driverSearchResult = [];

    @action
    search(q) {
        this.api.get(`/drivers/by-full-name/${q}`)
            .then(response => {
                if (response.status === 200) {
                    this.driverSearchResult = response.data;
                }
            })
    }

    get(id) {
        return this.api.get(`/drivers/${id}`)
            .then(response => {
                if (response.status === 200) {
                    return response.data;
                } else {
                    return null
                }
            })
    }

    getLastLocation(id) {
        return this.api.get(`/drivers/${id}/location`)
            .then(response => {
                if (response.status === 200) {
                    return response.data.length > 0 ? response.data[0] : null;
                } else {
                    return null
                }
            })
    }

  quit(id, query, callback) {
    return this.api.post(`/drivers/${id}/quit`, query).then(callback)
  }

  suspend(id, query, callback) {
    return this.api.post(`/drivers/${id}/suspend`, query).then(callback)
  }

  reactivate(id, query, callback) {
    return this.api.post(`/drivers/${id}/re-activate`, query).then(callback)
  }
}

export default DriverStore;
